<template>
  <div>
    <p>日均发货量折线图</p>
    <div id="Deliver" :style="{width: '100%', height: '400px'}" />
  </div>
</template>
<script>
import Vue from 'vue'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
export default {
  name: 'Hello',
  props: ["message3"],
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  watch: {
    message3: function(newVal, oldVal) {
      let arr = [];
      let sum = [];
      newVal.map(function(value, index) {
        arr.push(value.dateTime)
        sum.push(value.total)
      });
      this.drawLine(arr,sum);
    }
  },
  mounted() {
    this.drawLine()
  },
  methods: {
    drawLine(r,s) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.getElementById('Deliver'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['订单']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: r
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '订单',
            type: 'line',
            stack: '总量',
            data: s
          }
        ]
      })
    }
  }
}
</script>
